import React from "react";
import { useTranslation } from 'react-i18next';
import { Input } from "stories/forms";
import { Typography } from "stories/components";

// Tax treatment of an own security when it is sold (veroilmoitus 9A, #1570/#1571).
export const TAX_TREATMENT_OPTIONS = [
  { key: "investment", tKey: "tax_treatment_investment", label: "Sijoitusomaisuus" },
  { key: "personal_use", tKey: "tax_treatment_personal_use", label: "Henkilökohtaiseen käyttöön tarkoitettu omaisuus" },
  { key: "household_goods", tKey: "tax_treatment_household_goods", label: "Tavanomainen koti-irtaimisto" },
]

const TaxTreatmentSelect = ({ label, name = "tax_treatment", value, onChange, onBlur, error, errorText, disabled }) => {
  const { t } = useTranslation();
  return (
    <>
      <Input
        label={label || t("tax_treatment_label", "Verokohtelu")}
        type="select"
        name={name}
        value={value || "investment"}
        onChange={onChange}
        onBlur={onBlur}
        error={error}
        errorText={errorText}
        disabled={disabled}
      >
        {TAX_TREATMENT_OPTIONS.map(option => (
          <option key={option.key} value={option.key}>{t(option.tKey, option.label)}</option>
        ))}
      </Input>
      <Typography variant="small" className="text-gray mt-1">
        {t("tax_treatment_help", "Henkilökohtaisen käyttöomaisuuden, kuten auton tai veneen, ja koti-irtaimiston luovutustappio ei ole verotuksessa vähennyskelpoinen. Koti-irtaimiston luovutusvoitto on verovapaa 5 000 €:oon asti vuodessa.")}
      </Typography>
    </>
  )
}

export default TaxTreatmentSelect
